<template>
    <v-data-table
        :loading="!ready"
        loading-text="Caricamento in corso... Attendi"
        :headers="colonne"
        :items="innerDisponibilita"
        :disable-pagination="true"
        :disable-filtering="true"
        :disable-sort="true"
        :hide-default-footer="true">
        <template v-slot:top>
            <v-toolbar
                flat
            >
                <v-toolbar-title>&nbsp;</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog
                    v-model="dialog"
                    max-width="50%"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            dark
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            Nuova disponibilità
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-subtitle class="pb-0">
                            Aggiungi/Modifica disponibilità per questo docente
                            <v-dialog
                                v-model="dialogInfo"
                                width="600px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="lighten-5"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        Istruzioni
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Cosa sono le disponibilità?</span>
                                    </v-card-title>
                                    <v-card-text>
                                        Grazie allo strumento per gestire le <b>disponibilità</b> potrai aggiungere le
                                        regole per automatizzare
                                        la gestione del calendario.<br/>
                                        <br/>
                                        Potrai scegliere se il docente è disponibile a <b>partire da</b> un determinato
                                        giorno <b>fino ad</b> un altro giorno,<br/>
                                        se è disponibile solamente in alcune <b>fasce orarie</b>, o se è disponibile
                                        solamente alcuni <b>giorni della settimana</b>.<br/>
                                        <hr/>
                                        Ricorda che non è obbligatorio impostare un orario di fine o un giorno di fine,
                                        lo stesso vale per le date di inizio/fine.<br/>
                                        Quindi per esempio:
                                        <ul>
                                            <li>impostando solo da data di "inizio disponibilità" potrai calendarizzare
                                                il docente solo a partire dalla data scelta
                                            </li>
                                            <li>impostando solo da data di "fine disponibilità" non potrai più
                                                calendarizzare il docente oltre la data selezionata
                                            </li>
                                            <li>impostando solo "l'orario di inizio disponibilità" potrai calendarizzare
                                                il docente solo a partire da quell'orario
                                            </li>
                                            <li>impostando solo "l'orario di fine disponibilità" potrai calendarizzare
                                                il docente solo entro l'orario scelto
                                            </li>
                                        </ul>
                                        <hr/>
                                        Tutte le opzioni <b>si combinano</b> e non sono retroattive rispetto il
                                        calendario vigente, pertanto le potrai aggiornare quando vuoi.<br/>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="green darken-1"
                                            text
                                            @click="dialogInfo = false"
                                        >
                                            Tutto chiaro
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-card-subtitle>

                        <v-card-text class="availabilityPicker">
                            <v-container>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        class="mb-0 pb-0">
                                        <div style="font-weight:bold;">Periodo dal:</div>
                                        <v-date-picker mode="date"
                                                       :is24hr="true"
                                                       :masks="masks"
                                                       v-model="editedItem.disponibile_dalday"
                                                       timezone="Europe/Rome">
                                            <template v-slot="{ inputValue, togglePopover }">
                                                <div class='input-group'>
                                                     <span class="input-group-addon">
                                                         <v-btn icon small
                                                                color="primary"
                                                                @click="togglePopover({ placement: 'auto-start' })">
                                                            <i class="glyphicon glyphicon-calendar"></i>
                                                        </v-btn>
                                                    </span>
                                                    <input
                                                        class="form-control"
                                                        :value="inputValue"
                                                        readonly
                                                    />
                                                    <span class="input-group-addon"><v-btn
                                                        color="accent-3"
                                                        icon
                                                        small
                                                        @click="clearDate(editedItem,'disponibile_dalday')"
                                                    ><v-icon>mdi-delete</v-icon></v-btn></span>
                                                </div>
                                            </template>
                                        </v-date-picker>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        class="mb-0 pb-0">
                                        <div style="font-weight:bold;">Periodo al:</div>
                                        <v-date-picker mode="date"
                                                       :is24hr="true"
                                                       :masks="masks"
                                                       v-model="editedItem.disponibile_alday"
                                                       timezone="Europe/Rome">
                                            <template v-slot="{ inputValue, togglePopover }">
                                                <div class='input-group'>
                                                    <span class="input-group-addon">
                                                         <v-btn icon small
                                                                color="primary"
                                                                @click="togglePopover({ placement: 'auto-start' })">
                                                            <i class="glyphicon glyphicon-calendar"></i>
                                                        </v-btn>
                                                    </span>
                                                    <input
                                                        class="form-control"
                                                        :value="inputValue"
                                                        readonly
                                                    />
                                                    <span class="input-group-addon"><v-btn
                                                        color="accent-3"
                                                        icon
                                                        small
                                                        @click="clearDate(editedItem,'disponibile_alday')"
                                                    ><v-icon>mdi-delete</v-icon></v-btn></span>
                                                </div>
                                            </template>
                                        </v-date-picker>
                                    </v-col>
                                    <v-col cols="6" class="mb-0 pb-0">
                                        <div style="font-weight:bold;">Tempo dalle:</div>
                                        <v-date-picker mode="time"
                                                       :is24hr="true"
                                                       :minute-increment="15"
                                                       :masks="masksTime"
                                                       :model-config="modelConfig"
                                                       v-model="editedItem.disponibile_daltime"
                                                       @popoverWillShow="fixTime(editedItem,'disponibile_daltime')"
                                                       timezone="Europe/Rome">
                                            <template v-slot="{ inputValue, togglePopover }">
                                                <div class='input-group'>
                                                    <span class="input-group-addon">
                                                        <v-btn icon small
                                                               color="primary"
                                                               @click="togglePopover({ placement: 'auto-start' })">
                                                            <i class="glyphicon glyphicon-time"></i>
                                                        </v-btn>
                                                    </span>
                                                    <input
                                                        class="form-control"
                                                        :value="inputValue"
                                                        readonly
                                                    />
                                                    <span class="input-group-addon"><v-btn
                                                        color="accent-3"
                                                        icon
                                                        small
                                                        @click="clearDate(editedItem,'disponibile_daltime')"
                                                    ><v-icon>mdi-delete</v-icon></v-btn></span>
                                                </div>
                                            </template>
                                        </v-date-picker>
                                    </v-col>
                                    <v-col cols="6" class="mb-0 pb-0">
                                        <div style="font-weight:bold;">Tempo alle:</div>
                                        <v-date-picker mode="time"
                                                       :is24hr="true"
                                                       :minute-increment="15"
                                                       :model-config="modelConfig"
                                                       v-model="editedItem.disponibile_altime"
                                                       @popoverWillShow="fixTime(editedItem,'disponibile_altime')"
                                                       timezone="Europe/Rome">
                                            <template v-slot="{ inputValue, togglePopover }">
                                                <div class='input-group'>
                                                    <span class="input-group-addon">
                                                        <v-btn icon small
                                                               color="primary"
                                                               @click="togglePopover({ placement: 'auto-start' })">
                                                            <i class="glyphicon glyphicon-time"></i>
                                                        </v-btn>
                                                    </span>
                                                    <input
                                                        class="form-control"
                                                        :value="inputValue"
                                                        readonly
                                                    />
                                                    <span class="input-group-addon"><v-btn
                                                        color="accent-3"
                                                        icon
                                                        small
                                                        @click="clearDate(editedItem,'disponibile_altime')"
                                                    ><v-icon>mdi-delete</v-icon></v-btn></span>
                                                </div>
                                            </template>
                                        </v-date-picker>
                                    </v-col>
                                    <v-col cols="12">
                                        <b>Giorni della settimana</b>
                                        <v-container fluid class="mt-0 pt-0 mb-0 pb-0">
                                            <v-row>
                                                <v-col
                                                    cols="4"
                                                    sm="4"
                                                    md="4"
                                                    class="mb-0 pb-0" v-for="(week,k) in weekdays" :key="k">
                                                    <v-checkbox
                                                        v-model="editedItem.weekday"
                                                        :label="week.name"
                                                        :value="week.weekday"
                                                        hide-details
                                                    ></v-checkbox>
                                                </v-col>
                                                <v-col
                                                    cols="4"
                                                    sm="4"
                                                    md="4"
                                                    class="mb-0 pb-0">
                                                    <v-btn primary small @click="allDays(editedItem)">Tutti i giorni
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>

                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col :cols="12">
                                        Se non si seleziona alcun giorno della settimana, il docente sarà considerato
                                        disponibile <b>"in qualunque giorno"</b>.<br/>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue lighten-1"
                                text
                                @click="close"
                            >
                                Annulla
                            </v-btn>
                            <v-btn
                                color="green darken-1"
                                text
                                @click="save"
                            >
                                Salva
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="headline">Sei sicuro di voler eliminare questa regola?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDelete">Annulla</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">Si, elimina</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon
                small
                color="primary"
                class="mr-2"
                @click="editItem(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                small
                color="red darken-1"
                @click="deleteItem(item)"
            >
                mdi-delete
            </v-icon>
        </template>
        <template v-slot:no-data>
            <div class="text-center bold">
                Nessuna disponibilità impostata per il docente.<br/>
                <b>In questo caso il docente sarà considerato SEMPRE DISPONIBILE</b>
                <v-dialog
                    v-model="dialogInfo2"
                    width="600px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="lighten-5"
                            small

                            v-bind="attrs"
                            v-on="on"
                        >Info
                            <v-icon>mdi-help</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">Cosa sono le disponibilità?</span>
                        </v-card-title>
                        <v-card-text>
                            Grazie allo strumento per gestire le <b>disponibilità</b> potrai aggiungere le
                            regole per automatizzare
                            la gestione del calendario.<br/>
                            <br/>
                            Potrai scegliere se il docente è disponibile a <b>partire da</b> un determinato
                            giorno <b>fino ad</b> un altro giorno,<br/>
                            se è disponibile solamente in alcune <b>fasce orarie</b>, o se è disponibile
                            solamente alcuni <b>giorni della settimana</b>.<br/>
                            <hr/>
                            Ricorda che non è obbligatorio impostare un orario di fine o un giorno di fine,
                            lo stesso vale per le date di inizio/fine.<br/>
                            Quindi per esempio:
                            <ul>
                                <li>impostando solo da data di "inizio disponibilità" potrai calendarizzare
                                    il docente solo a partire dalla data scelta
                                </li>
                                <li>impostando solo da data di "fine disponibilità" non potrai più
                                    calendarizzare il docente oltre la data selezionata
                                </li>
                                <li>impostando solo "l'orario di inizio disponibilità" potrai calendarizzare
                                    il docente solo a partire da quell'orario
                                </li>
                                <li>impostando solo "l'orario di fine disponibilità" potrai calendarizzare
                                    il docente solo entro l'orario scelto
                                </li>
                            </ul>
                            <hr/>
                            Tutte le opzioni <b>si combinano</b> e non sono retroattive rispetto il
                            calendario vigente, pertanto le potrai aggiornare quando vuoi.<br/>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="green darken-1"
                                text
                                @click="dialogInfo2 = false"
                            >Tutto chiaro
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <template v-slot:item.disponibile_dalday="{ item }">
            <span v-if="item.disponibile_dalday">
                dal {{ formatTime(item.disponibile_dalday) }}
            </span>
            <span v-else>sempre</span>

        </template>
        <template v-slot:item.disponibile_alday="{ item }">
            <span v-if="item.disponibile_alday">
                al {{ formatTime(item.disponibile_alday) }}
            </span>
            <span v-else>sempre</span>
        </template>
        <template v-slot:item.disponibile_daltime="{ item }">
            <span v-if="item.disponibile_daltime">
                a partire dalle {{ formatTime(item.disponibile_daltime, 'HH:mm') }}
            </span>
            <span v-else>qualunque ora</span>

        </template>
        <template v-slot:item.disponibile_altime="{ item }">
            <span v-if="item.disponibile_altime">
                fino alle {{ formatTime(item.disponibile_altime, 'HH:mm') }}
            </span>
            <span v-else>qualunque ora</span>
        </template>
        <template v-slot:item.weekday="{ item }">
            <span v-if="item.weekday&&item.weekday.length>0">
                <span v-for="wk in item.weekday" class="comma-after">
                    {{ weekdays.filter((v) => v.weekday === wk)[0].name }}
                </span>
            </span>
            <span v-else>
                Qualunque giorno
            </span>
        </template>


    </v-data-table>
</template>
<script>
var moment = require('moment');
moment.locale("it");

var axios = require('axios');
export default {
    props: {
        "docenteid": "",
        "disponibilitaurl": "",
        "disponibilitadeleteurl": "",
        "disponibilita": {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            masks: {
                input: 'DD/MM/YYYY',
            },
            masksTime: {
                type: 'string',
                input: 'HH:mm'
            },
            modelConfig: {
                mask: 'HH:mm'
            },
            dialogInfo: false,
            dialogInfo2: false,
            menutimeDal: false,
            menutimeAl: false,
            dialog: false,
            dialogDelete: false,
            ready: false,
            innerDisponibilita: [],
            "colonne": [
                {
                    text: 'Periodo dal',
                    align: 'start',
                    sortable: false,
                    value: 'disponibile_dalday',
                },
                {
                    text: 'Periodo al',
                    align: 'start',
                    sortable: false,
                    value: 'disponibile_alday',
                },
                {
                    text: 'Ora dalle',
                    align: 'start',
                    sortable: false,
                    value: 'disponibile_daltime',
                },
                {
                    text: 'Ora alle',
                    align: 'start',
                    sortable: false,
                    value: 'disponibile_altime',
                },
                {
                    text: 'Giorni della settimana',
                    align: 'start',
                    sortable: false,
                    value: 'weekday',
                },
                {text: 'Azioni', value: 'actions', sortable: false}
            ],
            "weekdays": [
                {"weekday": 0, "name": 'Lunedì'},
                {"weekday": 1, "name": 'Martedì'},
                {"weekday": 2, "name": 'Mercoledì'},
                {"weekday": 3, "name": 'Giovedì'},
                {"weekday": 4, "name": 'Venerdì'},
                {"weekday": 5, "name": 'Sabato'}
            ],
            editedIndex: -1,
            editedItem: {
                disponibile_dalday: null,
                disponibile_alday: null,
                disponibile_daltime: null,
                disponibile_altime: null,
                weekday: [],
            },
            defaultItem: {
                disponibile_dalday: null,
                disponibile_alday: null,
                disponibile_daltime: null,
                disponibile_altime: null,
                weekday: [],
            },
        }
    },
    methods: {
        formatTime(time, formato) {
            let m = moment(time);
            if (m) {
                if (formato) {
                    return m.format(formato);
                }
                return m.format('L');
            } else {
                return time;
            }
        },
        allDays(object) {
            this.$set(object, 'weekday', []);
            this.weekdays.map((v) => object.weekday.push(v.weekday));
        },
        fixTime(object, kind) {
            object[kind] = new Date();
        },
        clearDate(object, kind) {
            object[kind] = null;
        },
        saveDal(date) {
            this.$refs.menuDal.save(date);
        },
        saveAl(date) {
            this.$refs.menuAl.save(date);
        },
        editItem(item) {
            this.editedIndex = this.innerDisponibilita.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            this.editedIndex = this.innerDisponibilita.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        cleanLocalStorageKey(docID) {
            //Start per :
            let searchKey = "docenti_availability_by_"+docID+"_";
            for(let i = 0;i<localStorage.length;i++) {
                let key = localStorage.key(i);
                if(key.indexOf(searchKey)>-1) {
                    //Found:
                    localStorage.removeItem(key);
                }
            }
        },
        deleteItemConfirm() {
            let deleteMe = this.innerDisponibilita[this.editedIndex];
            if (typeof deleteMe.id === 'undefined') {
                this.innerDisponibilita.splice(this.editedIndex, 1);
                this.closeDelete();
                return;
            }
            this.$isLoading(true);
            axios.delete(this.disponibilitadeleteurl.replace('~CAMBIAMI~', deleteMe.id))
                .then((r) => {
                    if (r && r.data && r.data.success) {
                        this.cleanLocalStorageKey(this.docenteid);
                        toastr.success('Disponibilità rimossa con successo');
                        this.innerDisponibilita.splice(this.editedIndex, 1);
                    } else {
                        console.error('si è verificato errore', r);
                        toastr.error('Impossibile rimuovere la disponibilità');
                    }
                }).catch((e) => {
                console.error('si è verificato errore', e);
                toastr.error('Impossibile salvare la disponibilità');
            })
                .finally(() => {
                    this.closeDelete();
                    this.$isLoading(false);
                });
        },
        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            })
        },

        closeDelete() {
            this.dialogDelete = false;


            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            this.$isLoading(true);
            this.editedItem.teacher_id = this.docenteid;
            axios.post(this.disponibilitaurl, this.editedItem)
                .then((r) => {
                    console.log(r);
                    if (r && r.data && r.data.success) {
                        this.cleanLocalStorageKey(this.docenteid);
                        toastr.success('Disponibilità salvata con successo');
                        if (r.data.object) {
                            this.editedItem.id = r.data.object.id;
                        }
                        if (this.editedIndex > -1) {
                            Object.assign(this.innerDisponibilita[this.editedIndex], this.editedItem)
                        } else {
                            this.innerDisponibilita.push(this.editedItem)
                        }
                    } else {
                        console.error('si è verificato errore', r);
                        toastr.error('Impossibile salvare la disponibilità');
                    }
                }).catch((e) => {
                console.error('si è verificato errore', e);
                toastr.error('Impossibile salvare la disponibilità');
            })
                .finally(() => {
                    this.close();
                    this.$isLoading(false);
                });
            /*
            if (this.editedIndex > -1) {
                Object.assign(this.innerDisponibilita[this.editedIndex], this.editedItem)
            } else {
                this.innerDisponibilita.push(this.editedItem)
            }
            */

        }
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Nuova disponibilità' : 'Modifica disponibilità'
        },
    },
    watch: {
        dialog(val) {
            val || this.close()
        },
        dialogDelete(val) {
            val || this.closeDelete()
        },

    },
    mounted() {
        $('#voyager-loader').remove();
        console.log('pronto a caricare');
        if (this.disponibilita && Array.isArray(this.disponibilita) && this.disponibilita.length > 0) {
            this.$set(this, 'innerDisponibilita', []);

            console.log(this.disponibilita);

            this.disponibilita.map((d) => {
                if (d.disponibile_daltime) {
                    d.disponibile_daltime = "2020-01-01 " + d.disponibile_daltime;
                }
                if (d.disponibile_altime) {
                    d.disponibile_altime = "2020-01-01 " + d.disponibile_altime;
                }
                this.innerDisponibilita.push(d);
            });
        }
        this.ready = true;
    }
}
</script>
